module.exports = __webpack_public_path__ + "dc0ddf6dc5532c69ba1face224ebc81a.svg";